<div class="status-container" [matTooltip]="getMismatchTooltip()" matTooltipClass="unset-max-width unset-max-width-warning">
  <mat-icon [svgIcon]="getMismatchIcon()"></mat-icon>
</div>
